import { Injectable } from '@angular/core';
import { HttpInterceptor } from './httpInterceptor.service';
import { ConfigService } from '../services/config.service';
@Injectable({
    providedIn: 'root'
})
export class WhatsappConsentService {
    constructor(private _httpInterceptor: HttpInterceptor) { }
    public AddConsent(data: any) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.addWhatsappConsent;
        return this._httpInterceptor.Post(url, data, true);
    }
    public GetConsent(data: any) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.getWhatsappConsent;
        return this._httpInterceptor.Post(url, data, true);
    }
    public AddPartnerConsent(data: any) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.addPartnerConsent;
        return this._httpInterceptor.Post(url, data, true);
    }
}
